// @index('./*.ts', f => `export * from '${f.path}';`)
export * from './core-front.config';
export * from './navigation.config';
// @endindex